import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

// A failed read must settle, and a response from a previous session must not update the screen.
async function channelRequest(action, idCanalAtendimento) {
    const token = JwtService.getToken();
    if(!token) throw new Error('Sessão expirada.');
    ApiService.setHeader();
    const { data } = await ApiService.postOnce(`canaisAtendimento/access/${action}`,
        { ID_CANAL_ATENDIMENTO: idCanalAtendimento }, { timeout: 20000 });
    if(JwtService.getToken() !== token) throw new Error('Sessão alterada.');
    return data;
}

const state = {};

const getters = {};

const mutations = {};

const actions = {
    async autorizarCanalSocial(context, dados) {
        const token = JwtService.getToken();
        if(!token) throw new Error('Sessão expirada.');
        ApiService.setHeader();
        const { data } = await ApiService.postOnce('canaisAtendimento/access/autorizarSocial', dados, { timeout: 50000 });
        if(JwtService.getToken() !== token) throw new Error('Sessão alterada.');
        return data;
    },
    registrarCanalSocial(context, id) { return channelRequest('registrarSocial', id); },
    registrarNumeroWhatsAppOficial(context, id) { return channelRequest('registrarWhatsAppOficial', id); },
    listarCanaisAtendimento() { return channelRequest('listar'); },
    obterLimitesCanaisAtendimento() { return channelRequest('limites'); },
    consultarConexaoCanal(context, id) { return channelRequest('consultarConexao', id); },
    obterCanalAtendimento(context, idCanalAtendimento) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("canaisAtendimento/access/obter", { ID_CANAL_ATENDIMENTO: idCanalAtendimento }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }, 
    excluirCanalAtendimento(context, idCanalAtendimento) {
        return new Promise((resolve, reject) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("canaisAtendimento/access/excluir", { ID_CANAL_ATENDIMENTO: idCanalAtendimento }).then(({ data }) => {
                    resolve(data);
                }).catch(reject);
            } else { reject(new Error('Sessão expirada.')); }
        });
    }, 
    async salvarCanalAtendimento(context, dados) {
        const token = JwtService.getToken();
        if(!token) throw new Error('Sessão expirada.');
        ApiService.setHeader();
        const { data } = await ApiService.postOnce('canaisAtendimento/access/salvar', dados, { timeout: 20000 });
        if(JwtService.getToken() !== token) throw new Error('Sessão alterada.');
        return data;
    }, 
    buscarQRCodeWhatsApp(context, id) { return channelRequest('buscarQRCodeWhatsApp', id); }, 
    buscarConexaoWhatsAppOficial(context, id) { return channelRequest('buscarConexaoWhatsAppOficial', id); }, 
    desconectarWhatsApp(context, idCanalAtendimento) {
        return new Promise((resolve) => {
            if (JwtService.getToken()) {
                ApiService.setHeader();
                ApiService.post("canaisAtendimento/access/desconectarWhatsApp", { ID_CANAL_ATENDIMENTO: idCanalAtendimento }).then(({ data }) => {
                    resolve(data);
                });
            }
        });
    }
};

export default {
    state,
    actions,
    mutations,
    getters
};
